import { authActions } from "./authSlice";
import CommonAPI from "../lib/common";
import { MY_PROFILE, LOGIN } from "../config/api-urls";
import toast from "react-hot-toast";
import CommonLocal from "../lib/commonLocal";

// export const login = () => {
//   return async (dispatch) => {
//     dispatch(authActions.login());
//   };
// };

export const login = (loginCredentials, navigate, handleClose) => {
  return async (dispatch) => {
    try {
      // const responseLocal = await CommonLocal(LOGIN, loginCredentials, "POST");
      // dispatch(authActions.loginLocal({ response: responseLocal }));
      const response = await CommonAPI(LOGIN, loginCredentials, "POST");
      dispatch(authActions.login({ response: response }));

      const profileResponse = await CommonAPI(MY_PROFILE);
      // console.log("ProfileResponse", profileResponse);
      dispatch(authActions.getProfile({ response: profileResponse }));
      {
        profileResponse.user?.is_superuser
          ? navigate("/super-admin-panel")
          : profileResponse.client_user_details.is_corporate_admin
          ? navigate("/company-admin-panel")
          : navigate("home");
      }

      handleClose();
      toast.success("Succesfully logged in..");
      return response;
    } catch (error) {
      // console.log(error);
      toast.error("Invalid Credentials");
      handleClose();
      if (error.response && error.response.data.message !== "") {
        dispatch(authActions.alert(error.response.data.message));
      } else {
        dispatch(authActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};
export const loginAdmin = (loginCredentials, navigate) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(LOGIN, loginCredentials, "POST");
      dispatch(authActions.login({ response: response }));
      navigate("/company-admin-panel");
      toast.success("Succesfully logged in..");
      return response;
    } catch (error) {
      // console.log(error);
      toast.error("Invalid Credentials");
      if (error.response && error.response.data.message !== "") {
        dispatch(authActions.alert(error.response.data.message));
      } else {
        dispatch(authActions.alert("Something went wrong. Please try again."));
      }
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    dispatch(authActions.logout());
  };
};

export const getProfile = () => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(MY_PROFILE);
      dispatch(authActions.getProfile({ response: response }));
      return response;
    } catch (error) {
      // console.log(error);
    }
  };
};
